<template>
  <div class="visit">
    <!-- 搜索框 -->
    <SearchBar @search="search" />

    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>
      <el-table-column label="楼盘名" align="center">
        <template slot-scope="scope">
          {{ scope.row.house && scope.row.house.houseName }}
        </template>
      </el-table-column>

      <el-table-column label="推荐人" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.reward }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户名" align="center">
        <template slot-scope="scope">
          {{ scope.row.customerName }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="客户电话" align="center">
        <template slot-scope="scope">
          {{ scope.row.customerPhone }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="身份证号码"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.lastSixId }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="销售员" align="center">
        <template slot-scope="scope">
          {{ scope.row.salesPersonName || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="客服" align="center">
        <template slot-scope="scope">
          {{ scope.row.customerServiceName || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          {{ statusList[scope.row.status] }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="看房时间" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.appointmentTime.split(' ')[0] || '' }}</div>
          <div>{{ scope.row.appointmentTime.split(' ')[1] || '' }}</div>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="修改人" align="center">
        <template slot-scope="scope" v-if="scope.row.update">
          {{ scope.row.update.userName }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="修改时间" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.reviewTime !== null">
            {{ scope.row.reviewTime.split(' ')[0] }}
          </div>
          <div v-if="scope.row.reviewTime !== null">
            {{ scope.row.reviewTime.split(' ')[1] }}
          </div>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="修改备注" align="center">
        <template slot-scope="scope">
          {{ scope.row.reviewOpinion || '' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <!-- <div class="btn"><el-button  size="small" icon="el-icon-edit" @click="onEdit(scope.row)" type="info" >编辑表单</el-button> </div> -->
          <div>
            <el-button
              type="text"
              size="mini"
              @click="onChangeStatus(scope.row)"
              >变更状态</el-button
            >
          </div>
          <!-- v-if="scope.row.status === 3" -->
          <div v-if="scope.row.status === 3">
            <el-button
              type="text"
              size="mini"
              @click="handleDistritution(scope.row)"
              >人工分配</el-button
            >
          </div>

          <div
            class="lookDetails"
            v-if="
              scope.row.status > 3 &&
              scope.row.status != 6 &&
              scope.row.status != 4
            "
          >
            <el-button type="text" size="mini" @click="lookDetails(scope.row)"
              >查看详情</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />
    <!-- 修改状态 -->
    <changeStatus ref="changeStatus" @fetchData="fetchData" />

    <manualAllocation ref="manualAllocation" @fetchData="fetchData" />

    <!-- 查看详情 -->
    <!--  v-if="detailObj" -->
    <!-- class="detail" -->
    <el-dialog
      title="详情"
      class="detail"
      :visible.sync="detailShow"
      width="30%"
    >
      <div class="detail-row">
        <span>备注: </span>{{ detailObj.reviewOpinion }}
      </div>
      <div class="detail-row">
        <span>到访时间:</span> {{ detailObj.arriveTime }}
      </div>
      <div class="detail-row">
        <span> 签约时间:</span> {{ detailObj.signedTime }}
      </div>
      <div class="detail-row">
        <span> 成交类型:</span> {{ detailObj.type === 1 ? '购' : '租' }}
      </div>
      <div class="detail-row">
        <span> 单价:</span> {{ detailObj.unitPrice }}
      </div>
      <div class="detail-row">
        <span> 总佣金:</span> {{ detailObj.totalBonus }}
      </div>
      <div class="detail-row">
        <span> 成交金额:</span> {{ detailObj.totalPrice }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRolePageApi } from '@/api/user';
import { searchSignedApi } from '@/api/introduce';
const changeStatus = () => import('./components/changeStatus'); // 增加表单
const manualAllocation = () => import('./components/manualAllocation');
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import SearchBar from './components/searchBar'; // 搜索框

export default {
  components: {
    changeStatus,
    manualAllocation,
    Pagination,
    SearchBar,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      detailShow: false,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      detailObj: {}, // 详情数据
      checkList: [], // 选中的列表
    };
  },
  created() {
    this.fetchData();
  },

  computed: {
    ...mapGetters(['paginObj', 'statusList']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData() {
      try {
        this.listLoading = true;
        let res = await getRolePageApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          ...this.fromSearchObj,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },

    // 搜索
    search(obj = {}) {
      if (obj) this.fromSearchObj = obj;
      // 重置页码
      this.$store.dispatch('area/setPaginObj', {
        pageIndex: 1,
        pageSize: 20,
      });
    },
    // 变更状态
    onChangeStatus(row) {
      this.$refs.changeStatus.dialogFormVisible = true;
      this.$refs.changeStatus.value = [this.statusList[row.status]];
      // console.log('row', row);
      this.$refs.changeStatus.editForm.opinion = row.remark;
      this.$refs.changeStatus.editForm.appRecordId = row.appRecordId;
    },

    // 人工分配
    handleDistritution(row) {
      this.$refs.manualAllocation.dialogFormVisible = true;
      // this.$refs.changeStatus.value = [this.statusList[row.status-1]]
      // this.$refs.changeStatus.editForm.opinion = row.remark
      this.$refs.manualAllocation.changeForm.appRecordId = row.appRecordId;
    },

    // 查看详情，只有已签约，可结佣，已结佣有这个功能
    async lookDetails(row) {
      await searchSignedApi(row.appRecordId).then((res) => {
        this.detailObj = res.data;
        if (this.detailObj) {
          // console.log(this.detailObj);
          this.detailShow = true;
        } else {
          this.$message.warning('暂无详情');
          // this.detailShow = false;
        }
      });
    },
  },
};
</script>

<style lang="less">
.visit {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.btn {
  margin-bottom: 10px;
}

.lookDetails {
  margin-top: 10px;
}

.detail {
  .detail-row {
    margin-top: 10px;
    display: flex;
    font-size: 16px;

    span {
      width: 100px;
      text-align: right;
      margin-right: 20px;
      font-weight: 550;
    }
  }
}
</style>
